<template>
  <div class="itineraryCardContainer">
    <span class="itineraryCardContainer__cheaper" v-if="isCheaper">
      <i class="fas fa-dollar-sign"></i>
      <span> {{ $t('best_price') }} </span>
    </span>
    <div class="itineraryCard" :class="{ ...classes, opened: upsellingOpened }">
      <div class="itineraryCard__container" @click="onClickCard">
        <div class="itineraryCard__body">
          <segment
            v-for="(segment, key) in journeyOrSegmentToEach"
            :key="`segment-${segment?.flight_id}_${key}`"
            :class="key ? '--return' : '--outbound'"
            :segment="segment"
            :airportsInformation="airportsInformation"
            @openFlightDetail="openFlightDetail"
          >
          </segment>
        </div>
        <!-- Si me llega la prop fare, muestro eso, si no, muestro journey.fare -->
        <ItineraryFooter
          @onCloseUpselling="$emit('onCloseUpselling')"
          :fare="journey?.fare"
        ></ItineraryFooter>
      </div>
      <transition name="upselling">
        <Upselling
          v-if="upsellingOpened"
          :class="{ '--opened': upsellingOpened }"
          :upselling="journey.upselling"
          :tripSegment="journey.trip_segment"
          :minimumPrice="journey.minimum_price"
          ref="upselling"
          @onCloseUpselling="$emit('onCloseUpselling')"
          @onFareSelected="
            (fareSelected) => $emit('onFareSelected', fareSelected)
          "
          :termsConditionsOpened="termsConditionsOpened"
        />
      </transition>
    </div>
    <div v-if="showFlightRemarks && remarks" class="itineraryCard__Remarks">
      {{ remarks }}
    </div>
  </div>
</template>
<script>
import Segment from './Segment'
import ItineraryFooter from './ItineraryFooter'
import flightDetails from './flightDetails.vue'
import Upselling from '../upselling/upselling.vue'
import mixinMethods from '../../helpers/mixinMethods.js'

export default {
  name: 'ItineraryCard',
  mixins: [mixinMethods],
  props: {
    journey: {
      required: true,
    },
    airportsInformation: {
      required: false,
      type: Object,
    },
    upsellingOpened: {
      type: Boolean,
      required: false,
    },
    termsConditionsOpened: {
      type: Boolean,
      required: false,
    },
    isCheaper: {
      type: Boolean,
      default: false,
    },
    classes: {
      type: Object,
      required: false,
    },
  },
  inject: ['configurations'],
  data: function () {
    return {
      ffams: null,
      remarks: null,
    }
  },
  components: {
    Segment,
    ItineraryFooter,
    Upselling,
  },
  methods: {
    onClickCard: function () {
      this.$emit('click')
    },
    openFlightDetail: function () {
      this.parseAirportInformationMixinMethod(
        this.journey,
        this.airportsInformation
      )
      this.$openModal(
        flightDetails,
        { flightDetail: this.journey },
        {
          title: this.$t('shopping_lib.flight_details'),
          buttons: [
            {
              label: this.$t('back_button'),
              icon: 'fas fa-times mr-2',
              classes: 'btn btn-primary',
              handler: () => this.$closeModal(),
            },
          ],
        }
      )
    },
    getRemarks() {
      const Remarks = []
      this.journey.flight_detail.forEach((detail) => {
        if (
          detail.legal_restriction &&
          !Remarks.includes(detail.legal_restriction)
        ) {
          Remarks.push(detail.legal_restriction)
        }
      })
      return Remarks.length > 0 ? Remarks.join(' / ') : null
    },
  },
  mounted() {
    if (this.showFlightRemarks) {
      this.remarks = this.getRemarks()
    }
  },
  computed: {
    journeyOrSegmentToEach: function () {
      return Array.isArray(this.journey) ? this.journey : [this.journey]
    },
    showFlightRemarks() {
      return this.configurations.showFlightRemarks
    },
  },
}
</script>

<style scoped lang="sass">
// vue animations
.upselling-enter-active, .upselling-leave-active
  transition: opacity 0.1s

.upselling-enter, .upselling-leave-to
  opacity: 0
.itineraryCardContainer
  display: flex
  flex-direction: column
  // gap: .4rem
.itineraryCardContainer__cheaper
  border-radius: var(--b-radius-md)
  background-color: var(--color-success)
  padding: 0 .5rem
  color: var(--color-onSuccess)
  display: flex
  gap: 0.2rem
  align-items: center
  max-width: fit-content
.itineraryCard
  border: 2px solid var(--color-overlay-10)
  border-top-width: .8rem
  border-radius: var(--b-radius-md)
  &.--selected, &:hover
    border-color: var(--color-primary)
  &.--disabled .itineraryCard__container
    background-color: var(--color-background)
    pointer-events: none
  &.opened::v-deep
    .itineraryFooter__displayFares
      i
        transform: rotate(180deg)
      // cursor: pointer
.itineraryCard__container
  display: flex
  flex-direction: column
  background-color: var(--color-surface)
  color: var(--color-onSurface)
  &:hover
    .itineraryCard__footer
      &:after
        opacity: .15
.itineraryCard__label
  display: flex
  padding: .5rem .75rem
  align-items: baseline
  font-size: var(--font-size-sm)
  font-weight: 600
  color: var(--color-primary)
  span
    margin-left: 5px
.itineraryCard__body
  display: flex
  flex-direction: column
.itineraryCard__Remarks
  display: flex
  width: 100%
  padding: .1rem .1rem .1rem .1rem
  font-size: var(--font-size-sm)
  align-items: center
  justify-content: center
  flex-direction: column
  background-color: var(--color-primary)
  color: var(--color-onPrimary)
  font-weight: 600
  border-bottom-left-radius: var(--b-radius-md)
  border-bottom-right-radius: var(--b-radius-md)
  margin-top: -0.15rem
  z-index: 1

@media (min-width: 768px)
  .itineraryCard__body
    flex: 1
  .itineraryCard
    &.--selected
      border-color: var(--color-primary)
@media (min-width: 1024px)
  .itineraryCard
    border-left-width: .8rem
    border-top-width: 2px
  .itineraryCard__container
    flex-direction: row
    flex-wrap: wrap
</style>
